import Logger from "../../utils/log";
export var LogInfo = function LogInfo() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  Logger.info('perf日志: ', args);
};
export var LogError = function LogError() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  Logger.warn("perf\u65E5\u5FD7: ".concat(typeof args === 'string' ? args : JSON.stringify(args)));
};